import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import StockReturnService from '../services/StockReturnService';

const initialState = {
  data: [],
  datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  submitLoading: false,
  isPendingStockReturnDetail: false,
  isOpenInventoryDialog: false,
  details: {},
  returnItems: [],
};

export const fetchStockReturnList = createAsyncThunk(
  'stockReturn/fetchList',
  async ({ perPage, page, shop_id, date, status, keyword }, { rejectWithValue }) => {
    try {
      const response = await StockReturnService.All({
        per_page: perPage,
        page,
        shop_id,
        date,
        status,
        keyword,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const fetchStockReturnDetail = createAsyncThunk('stockReturn/fetchStockReturnDetail', async (id, { rejectWithValue }) => {
  try {
    const resp = await StockReturnService.Details(id);
    return resp;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateStockReturnStatus = createAsyncThunk('stockReturn/updateStatus', async ({ id, ...data }, { rejectWithValue }) => {
  try {
    const resp = await StockReturnService.UpdateStatus(id, data);
    return resp;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const stockReturnSlice = createSlice({
  name: 'stockReturn',
  initialState: initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockReturnList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchStockReturnList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data?.returnList];
          state.pagination = action.payload?.data?.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(fetchStockReturnList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(fetchStockReturnDetail.pending, (state, action) => {
        state.isPendingStockReturnDetail = true;
      })
      .addCase(fetchStockReturnDetail.fulfilled, (state, action) => {
        state.isPendingStockReturnDetail = false;
        state.details = action.payload.data.data;
        state.returnItems = action.payload.data.data.items || [];
      })
      .addCase(fetchStockReturnDetail.rejected, (state, action) => {
        state.isPendingStockReturnDetail = false;
      })
      .addCase(updateStockReturnStatus.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(updateStockReturnStatus.fulfilled, (state, action) => {
        state.submitLoading = false;
        if (action.payload?.status === 200) {
          const updatedReturn = action.payload.data?.data;
          if (state.datas && state.datas.length > 0) {
            state.datas = state.datas.map((item) =>
              item.id === updatedReturn?.id ? { ...item, ...updatedReturn } : item
            );
          }
          toast.success(action.payload?.data?.message || 'Status updated successfully');
        } else {
          toast.error(action.payload?.data?.message || 'Failed to update status');
        }
      })
      .addCase(updateStockReturnStatus.rejected, (state, action) => {
        state.submitLoading = false;
        toast.error(action.payload?.message || 'Something went wrong');
      });
  },
});

const { reducer } = stockReturnSlice;

export const stockReturnSelector = (state) => state?.stockReturn;

export default reducer;